import { POST_RESERVATION_PROVIDER_FAILURE, POST_RESERVATION_PROVIDER_REQUEST, POST_RESERVATION_PROVIDER_SUCCESS, PostReservationProviderActionTypes, PostReservationProviderState } from './types';

const defaultState: PostReservationProviderState = {
  isLoading: false,
  errorMessage: "",
};

export default function postReservationProvider(state = defaultState, action: PostReservationProviderActionTypes): PostReservationProviderState {
  switch (action.type) {
    case POST_RESERVATION_PROVIDER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case POST_RESERVATION_PROVIDER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case POST_RESERVATION_PROVIDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
